import { useFormikContext, getIn } from 'formik';
import { InputType } from '../../utils/@globalTypes';
import { KIDS_AGES_REQ, kidsAgeMask } from '../../utils/constants';
import Input from '../Input';
import Tooltip from '../Tooltip';
import styles from './KidsAgesRange.module.scss';

type KidsAgesType = {
  itemName: string;
};

const KidsAgesRange = ({ itemName }: KidsAgesType) => {
  const { handleChange, values, setFieldTouched, touched, errors } =
    useFormikContext();

  const error = getIn(errors, `${itemName}.end_age`);
  const touchedField = getIn(touched, `${itemName}.end_age`);
  const startValue = getIn(values, `${itemName}.start_age`);
  const endValue = getIn(values, `${itemName}.end_age`);

  return (
    <div className={styles.ageLine}>
      <div className={styles.text}>
        дети
        <span className={styles.countAge}> {startValue} </span>-
      </div>
      <div className={styles.kidsAges}>
        <Input
          placeholder="Возраст"
          type={InputType.MASK}
          mask={kidsAgeMask}
          value={endValue?.toString() || ''}
          onChange={handleChange(`${itemName}.end_age`)}
          containerClassName={'kidsAge'}
          errText={touchedField && error}
          onBlur={() => setFieldTouched(`${itemName}.end_age`)}
        />
      </div>
      <div className={styles.text}>лет включительно</div>
      <div className={styles.text}>
        <Tooltip requirementsText={KIDS_AGES_REQ} error={!!error} />
      </div>
    </div>
  );
};
export default KidsAgesRange;
